export enum SvcAlertParameters {
  ShowTabActionPlan = 'INTEGRATION_ALR_ACP_REVAMP',
  ShowExportAction = 'WORK_COUNCILS',
  ShowVoiceToText = 'SPEECH_TO_TEST',
}
